<app-table (parentFunc)="tablerowfunc($event)" [sizeOptions]="sizeOptions" [Title]="invalidTitle" [Collection]="Collection" [displayedColumns]="displayedColumns" [sortOptions]="sortOptions"></app-table>
